import { useMutation } from '@tanstack/react-query';
import { UpdatePriceListResponse } from '@spilca/order_ts/v1/order_web/pricing_web_pb';
import { Pricing } from '@spilca/order_ts/v1/order/model_pricing_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useUpdatePriceList = () => {
  const mutator = useGetRequest(REQUEST_TYPES.UPDATE_PRICE_LIST);

  return useMutation<
    UpdatePriceListResponse.AsObject | null,
    TGRPCPromiseReject,
    Pricing.AsObject
  >({
    mutationFn: mutator,
    retry: false
  });
};

export default useUpdatePriceList;
